import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { AUTH_SERVER_URL } from '../config';
import { PaginatedResult } from '../shared/models/paginated-result';
import { User } from '../shared/models/user';

import { Users, FieldOfUsers } from './models/administration';

const GET_USER_URL = `${ AUTH_SERVER_URL }/v2/users`;

@Injectable({
	providedIn: 'root',
})
export class AdminService {
	loggedUser: User | undefined;
	constructor(private readonly http: HttpClient) {}
	getPendUsers(
		index: number,
		limit: number,
		onlyDistinct: boolean,
		fields: readonly FieldOfUsers[],
		filter: string | undefined
	) {
		const url = new URL(GET_USER_URL);
		const params = url.searchParams;
		params.append('fields', fields.join(','));
		if (filter) {
			params.append('filter', filter.replace(/\*/g, ''));
		}
		params.append('page', String(Math.floor(index / limit) + 1));
		params.append('limit', String(limit));
		params.append('distinct', String(onlyDistinct));
		return this.http.get<PaginatedResult<Users>>(url.toString());
	}

	async updateMemberRole(
		userId: number,
		orgId: number,
	) {
		const url = new URL(`${ GET_USER_URL }/${ userId }/organizations/${ orgId }/validate-role`);
		return firstValueFrom(this.http.put(url.toString(), null));
	}

	rejectUserRole(
		userId: number,
		orgId: number,
	) {
		const url = new URL(`${ GET_USER_URL }/${ userId }/organizations/${ orgId }/reject-role`);
		return this.http.delete(url.toString());
	}
}
